// extracted by mini-css-extract-plugin
export default {"content":"_2fGEi","noData":"_2rXmk"};